module.exports = __webpack_public_path__ + "static/Zoltan-2f4bada75916be17b4319384a90a4366.png";